import { Store, MenuState } from 'store/types';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';

// basic routes
import LoginRoutes from './LoginRoutes';
import StaticRoutes from './StaticRoutes';
import FallbackRoutes from './FallbackRoutes';

// main app routes
import MainRoutes from './MainRoutes';
import CmsRoutes from './CmsRoutes';
import AdminRoutes from './AdminRoutes';

// q-live partner bundle routes
import NetworkRoutes from './NetworkRoutes';
import PartnerRoutes from './PartnerRoutes';
import OrderRoutes from './OrderRoutes';

// q-live cronjob bundle routes
import CronjobRoutes from './CronjobRoutes';

// q-live chat bundle routes
import ChatRoutes from './ChatRoutes';

// q-live property management bundle routes
import DistrictRoutes from './DistrictRoutes';
import PropertyRoutes from './PropertyRoutes';
import ReportTopicRoutes from './ReportTopicRoutes';
import CalendarRoutes from './CalendarRoutes';

// q-live thriftshop bundle routes
import ThriftShopRoutes from './ThriftshopRoutes';

// ==============================|| ROUTING ||============================== //
export default function Routes() {
    const { extensions } = useSelector<Store, MenuState>(state => state.menu);
    const ModifiedRoutes = MainRoutes;

    // add cms routes to general route object
    if (extensions.enabled?.includes('qlive_core_cms')) {
        ModifiedRoutes.children?.push(CmsRoutes);
    }
    // add admin routes to general route object
    if (extensions.enabled?.includes('qlive_core_admin')) {
        ModifiedRoutes.children?.push(AdminRoutes);
    }

    // add partner routes to general route object
    if (extensions.enabled?.includes('qlive_partner')) {
        ModifiedRoutes.children?.push(NetworkRoutes);
        ModifiedRoutes.children?.push(PartnerRoutes);
        ModifiedRoutes.children?.push(OrderRoutes);
    }

    // add cronjob routes to general route object
    if (extensions.enabled?.includes('qlive_cronjob')) {
        ModifiedRoutes.children?.push(CronjobRoutes);
    }

    if (extensions.enabled?.includes('qlive_chat')) {
        ModifiedRoutes.children?.push(ChatRoutes);
    }

    if (extensions.enabled?.includes('qlive_property_management')) {
        ModifiedRoutes.children?.push(DistrictRoutes);
        ModifiedRoutes.children?.push(PropertyRoutes);
        ModifiedRoutes.children?.push(ReportTopicRoutes);
        ModifiedRoutes.children?.push(CalendarRoutes);
    }

    if (extensions.enabled?.includes('qlive_thriftshop')) {
        ModifiedRoutes.children?.push(ThriftShopRoutes);
    }

    return useRoutes(
        [ModifiedRoutes, LoginRoutes, StaticRoutes, FallbackRoutes],
        window.location,
    );
}
